/**
 * Created by mykurisu on 2017/11/10.
 */
import React from 'react'
import '../../css/wkCommon.css'


class WKCommentDialog extends React.Component {
    render() {
        const {title, buttons, children, show} = this.props;

        return (
            <div className="wk__comment__dialog" style={{display: show ? 'block' : 'none'}}>
                <div className="dialog__mask">
                    <div className="dialog__area">
                        <div className="area__title">
                            {title}
                        </div>
                        <div className="area__input">
                            {children}
                        </div>
                        <div className="area__btn">
                            {buttons.map((item, index) => {
                                return (
                                    <div className="btn__item" key={index}
                                         style={{color: item.type === 'default' ? '#353535' : '#0BB20C'}}
                                    onClick={() => item.onClick()}>
                                        {item.label}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default WKCommentDialog



// WEBPACK FOOTER //
// ./src/components/wk/WKCommentDialog.js